import React, { Component } from 'react';
import { createStructuredSelector } from 'reselect';
import { Link, withRouter } from 'react-router-dom';

import './index.scss';

import { Table } from 'elements';

const columns = order => [
	{
		title: 'Name',
		dataIndex: 'name',
		key: 'name',
		defaultSortOrder: order,
		render: (name, row) => <span style={{ color: '#00a7c0' }}>{name}</span>,
		sorter: (a, b) => a.name.trim().localeCompare(b.name.trim()),
	},
	{
		title: 'ID',
		dataIndex: 'clientReference',
		key: 'clientReference',
		render: (clientReference, row) => <span style={{ color: '#00a7c0' }}>{clientReference}</span>,
		sorter: (a, b) => a.clientReference.trim().localeCompare(b.clientReference.trim()),
	},
	{
		title: 'Status',
		dataIndex: 'active',
		key: 'active',
		render: active => (active ? 'Active' : 'Deactivated'),
	},
];

const handleRow = (row, history, search) => {
	return {
		onClick: e => {
			e.stopPropagation();
			history.push(`/directory/${row.clientReference}${search}`);
		},
	};
};
const ListView = ({
	loading,
	holders,
	onPageChange,
	onTableChange,
	page,
	perPage,
	history,
	location,
	order,
}) => {
	const getColumns = columns(order);
	return (
		<Table
			className={'directory-list'}
			onRow={row => handleRow(row, history, location.search)}
			dataSource={holders}
			onChange={onTableChange}
			columns={getColumns}
			loading={loading}
			pagination={{
				defaultPageSize: 10,
				showSizeChanger: true,
				size: 'small',
				current: parseInt(page, 10),
				pageSize: parseInt(perPage, 10),
				pageSizeOptions: ['25', '50', '100'],
				onChange: (page, pageSize) =>
					onPageChange('list', page, pageSize),
				onShowSizeChange: (current, size) =>
					onPageChange('list', 1, size),
			}}
			rowKey="clientReference"
		/>
	);
};

export default withRouter(ListView);



// WEBPACK FOOTER //
// ./src/pages/directory/contact-list/components/list-view/index.js